<template lang="pug">
.blue-shadow2
  //img(src="~assets/card-shadow.png")
  
</template>
<script>
export default {
  name: 'BlueShadow2',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.blue-shadow2
  position: absolute
  width: 120%
  height: pxToRem(190)
  left: -10%
  bottom: -20%
  z-index: -1
  opacity: 1
  background: url("~assets/card-shadow.png") no-repeat
  background-size: 100% 100%
  //background-position: -10% 0
  //img
    width: 100%
    object-fit:
</style>
